import React from 'react';
import Moment from 'moment';
import { prefix, t } from '../../../../i18n';
import CustomDataTable from '../../shared/CustomDataTable';
import { Check, CloseMD, formatDate } from '../../normalizer';
import CustomButton from '../../shared/CustomButton';

const tTrade = prefix('trades');

/**
 * Pending Trades Table component using CustomDataTable
 */
const SaleTable = ({ trades, onReject, onAccept, page, pagination, onPageChange }) => {
  const className = 'pending-trades-table';

  const handleAccept = (trade) => (e) => { e.preventDefault(); onAccept(trade); };
  const handleReject = (trade) => (e) => { e.preventDefault(); onReject(trade.id); };

  const columns = [
    {
      key: 'date',
      label: tTrade('registry-date'),
      sortKey: 'date',
      render: (_v, item) => formatDate(item.date),
    },
    {
      key: 'user_requester',
      label: tTrade('user-requester'),
      sortKey: 'user_requester',
    },
    {
      key: 'description',
      label: tTrade('description'),
      sortKey: 'description',
    },
    {
      key: 'status',
      label: tTrade('status'),
      sortKey: 'status',
      render: (_v, item) => (
        <span className={`${className}__cell--status ${className}__cell--status--badge ${className}__cell--status--${item.status}`}>
          {tTrade(item.status)}
        </span>
      ),
    },
    {
      key: 'actions',
      label: 'Ações',
      sortKey: 'actions',
      sortable: false,
      render: (_v, item) => {
        if (item.status !== 'pending') return <span></span>;
        return (
          <div className={`data-table__cell-container ${className}__cell--actions-container`}>
            <CustomButton link tight onClick={handleAccept(item)} success>
              <Check />Aceitar
            </CustomButton>
            <CustomButton link tight onClick={handleReject(item)} error>
              <CloseMD />Rejeitar
            </CustomButton>
          </div>
        );
      },
    },
  ];

  const sortFn = (data, sort) => {
    return [...data].sort((a, b) => {
      const multiplier = sort.direction === 'asc' ? 1 : -1;
      if (sort.key === 'date') {
        return (new Date(a.date) - new Date(b.date)) * multiplier;
      }
      const valA = (a[sort.key] || '').toString().toLowerCase();
      const valB = (b[sort.key] || '').toString().toLowerCase();
      return valA.localeCompare(valB) * multiplier;
    });
  };

  const handlePageChange = (pageNumber) => {
    onPageChange({ selected: pageNumber - 1 });
  };

  const renderRow = (trade, index, className) => {
    const handleOnAccept = (e) => {
      e.preventDefault();
      onAccept(trade);
    };

    const handleOnReject = (e) => {
      e.preventDefault();
      onReject(trade.id);
    };

    const isPending = trade.status === 'pending';

    return (
      <tr
        key={trade.id || index}
        className={`data-table__row ${className}__row`}
      >
        <td className={`data-table__cell ${className}__cell ${className}__cell--date`}>
          {formatDate(trade.date)}
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--user_requester`}>
          {trade.user_requester}
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--description`}>
          {trade.description}
        </td>
        <td className={`data-table__cell ${className}__cell ${trade.status} ${className}__cell--status`}>
          <span className={`${className}__cell--status ${className}__cell--status--badge ${className}__cell--status--${trade.status}`}>
            {tTrade(trade.status)}
          </span>
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--actions`}>
          {isPending ? (
            <div className={`data-table__cell-container ${className}__cell--actions-container`}>
              <CustomButton link tight onClick={handleOnAccept} success >
                <Check />Aceitar
              </CustomButton>
              <CustomButton link tight onClick={handleOnReject} error >
                <CloseMD />Rejeitar
              </CustomButton>
            </div>
          ) : (
            <span></span>
          )}
        </td>
      </tr>
    );
  };

  return (
    <CustomDataTable
      className="pending-trades-table"
      columns={columns}
      data={trades}
      renderRow={renderRow}
      rowKey={(item) => item.id}
      defaultSort={{ key: 'date', direction: 'desc' }}
      sortFn={sortFn}
      pagination={{
        totalPages: pagination.total_pages,
        currentPage: page,
        onPageChange: handlePageChange,
      }}
      emptyMessage="Não lhe foram propostas trocas de contratos."
    />
  );
};

export default SaleTable;
